import { colors } from "common/const/colors";
export const NotificationType = Object.freeze({
  BOOKING: colors.Sky,
  CHECK_IN: colors.Salmon,
  CHANGE_PASSPORT: colors.Forest,
  CANCEL: colors.Salmon,
  CHECK_OUT: colors.GrayBlue,
  ERROR: colors.Red,
});
